import React, { Component, Fragment } from "react";
import ReactHTMLTableToExcel from "../ReactHtmlToExcel";
import dayjs from "dayjs";
import { _cloneArray, _memoize, _capitalizeText } from "../../Utils/helpers";

class ExportOrders extends Component {
	constructor(props) {
		super(props);
		this.state = {
			orders: [],
			loading: false,
		};
	}

	getOrdersList = () => {
		if (this.state.loading) {
			return;
		}
		this.setState({ loading: true }, () => {
			setTimeout(async () => {
				let ordersList = await this.props.getOrders();
				ordersList = _cloneArray(ordersList);
				let orders = this.createTableOrders(ordersList);
				this.setState({ orders }, () => {
					setTimeout(() => {
						if (document.querySelector(".order-processing-click-to-download")) {
							document
								.querySelector(".order-processing-click-to-download")
								.click();
						}

						setTimeout(() => {
							this.setState({ orders: [], loading: false });
						}, 500);
					}, 500);
				});
			}, 500);
		});
	};

	createTableOrders = ordersList => {
		let orders = [];
		const memoizedTurnAround = _memoize(this.getTurnAroundTime);
		const memoizedUserZone = _memoize(this.getUserZone);
		const memoizedUserRole = _memoize(this.getUserRole);
		if (ordersList && ordersList.length) {
			ordersList.forEach(el => {
				el.turnAroundTime = el.OrderDeliveredDate
					? memoizedTurnAround(
							dayjs(el.OrderDeliveredDate).diff(el.Createddate, "minute"),
					  )
					: el.OrderCancelDate
					? memoizedTurnAround(
							dayjs(el.OrderCancelDate).diff(el.Createddate, "minute"),
					  )
					: el.OrderRTODate
					? memoizedTurnAround(
							dayjs(el.OrderRTODate).diff(el.Createddate, "minute"),
					  )
					: "";
				el.userZone = memoizedUserZone(el.Agentid);
				el.roleName = memoizedUserRole(el.Agentid);
				if (el.ItemDetails) {
					el.ItemDetails.forEach(itemDetail => {
						itemDetail.info = el;

						orders.push(itemDetail);
					});
				}
			});
		}

		return orders;
	};

	getTurnAroundTime = mins => {
		try {
			if (mins < 0) {
				return "";
			}
			let minutesInDays = 24 * 60,
				minutesInHours = 60,
				days = Math.floor(mins / minutesInDays),
				hours = Math.floor((mins - days * minutesInDays) / minutesInHours),
				minutes = Math.round(
					mins - days * minutesInDays - hours * minutesInHours,
				),
				prependZero = n => (n < 10 ? `0${n}` : n);
			if (minutes === 60) {
				hours++;
				minutes = 0;
			}
			if (hours === 24) {
				days++;
				hours = 0;
			}
			return [days, prependZero(hours), prependZero(minutes)].join(":");
		} catch (error) {
			return "";
		}
	};

	getUserZone = userId => {
		try {
			if (!this.props.users || !this.props.users.length) {
				return "";
			}
			for (const user of this.props.users) {
				if (Number(user.Userid) === Number(userId)) {
					if (user.addresslevel && typeof user.addresslevel === "string") {
						const zoneLevelData = JSON.parse(user.addresslevel);
						const zoneData = zoneLevelData.find(
							el => el.Levelname && el.Levelname.toLowerCase() === "zone",
						);
						if (zoneData) {
							return zoneData.levelvalue;
						}
					}
				}
			}
			return "";
		} catch (error) {
			return "";
		}
	};

	getUserRole = userId => {
		try {
			if (!this.props.users || !this.props.users.length) {
				return "";
			}
			for (const user of this.props.users) {
				if (Number(user.Userid) === Number(userId)) {
					return user.RoleName || "";
				}
			}
			return "";
		} catch (error) {
			return "";
		}
	};

	render() {
		return (
			<div>
				{this.props.show && (
					<Fragment>
						{this.state.orders.length > 0 && this.props.BusinessId > 0 ? (
							<Fragment>
								<ReactHTMLTableToExcel
									id="orders-xls-button"
									className="order-processing-click-to-download"
									table="orders-to-xls"
									filename="Orders"
									sheet="Orders"
								>
									<div className="show--desktop flex align-center">
										<Fragment>
											{!this.state.loading ? (
												<img
													src="Images/download-button.svg"
													alt=""
													style={{
														position: "relative",
														top: "0.5px",
														opacity: 0.6,
													}}
												/>
											) : (
												<span
													className="loading-circle loading-circle-light loading-circle-small"
													style={{ marginRight: "5px" }}
												></span>
											)}
											Download
										</Fragment>
									</div>
								</ReactHTMLTableToExcel>

								<table id="orders-to-xls" style={{ display: "None" }}>
									<tbody>
										<tr>
											<th>Order Date and Time</th>
											{!this.props.isSupplyRequestOrder &&
											this.props.context.isOmsAdminBusiness ? (
												<th>Order Number</th>
											) : (
												<Fragment>
													<th>Order Number</th>
													<th>SR Number</th>
												</Fragment>
											)}
											<th>Shipment Number</th>
											<th>Customer Name</th>
											<th>Zone</th>
											<th>Order Item Id</th>
											<th>Sku code</th>
											<th>Sku name</th>
											<th>Quantity</th>
											<th>Selling Price</th>
											<th>Buying Price</th>
											<th>Cost</th>
											<th>Total Items</th>
											<th>Amount</th>
											<th>Coupon Discount</th>
											<th>Promo Discount</th>
											<th>Wallet Discount</th>
											<th>Omoni Discount</th>
											<th>Total Discount</th>
											<th>Customer Phone</th>
											<th>Order Source</th>
											<th>Call center Agent</th>
											<th>Assigned To</th>
											<th>Role</th>
											<th>Status</th>
											<th>Order Cancelled Reason</th>
											<th>Order Confirmation Note</th>
											<th>Location</th>
											<th>State</th>
											<th>Lga</th>
											<th>Town</th>
											<th>Order Delivered Date</th>
											<th>Order Cancelled Date</th>
											<th>Order RTO Date</th>
											<th>Turn Around Time</th>
											<th>SO Number</th>
											<th>Waybill Number</th>
											<th>Payment Reference</th>
											<th>Transaction Id</th>
										</tr>
										{this.state.orders.map((item, index) => {
											const isSfaOrder =
												item.info.OmniOrderSource &&
												item.info.OmniOrderSource.toLowerCase() === "sfa";
											return (
												<tr index={index} key={index}>
													<td>
														{dayjs(item.info.Createddate).format(
															"YYYY-MM-DD H:mm",
														)}
													</td>
													{!this.props.isSupplyRequestOrder &&
													this.props.context.isOmsAdminBusiness ? (
														<td>{item.info.Orderid || ""}</td>
													) : (
														<Fragment>
															<td>{item.info.MasterOrderId || ""}</td>
															<td>{item.info.Orderid || ""}</td>
														</Fragment>
													)}
													<td>{item.info.shipmentId || ""}</td>
													<td>{item.info.CustomerName || ""}</td>
													<td>{item.info.userZone || ""}</td>
													<td>{item.ItemID}</td>
													<td>{_capitalizeText(item.skucode)}</td>
													<td>{`${_capitalizeText(item.ItemName)} ${
														item.unit ? `(${item.unit.toLowerCase()})` : ""
													}`}</td>
													<td>{item.Quantity}</td>
													<td>{item.Price}</td>
													<td>{item.BuyingPrice}</td>
													<td>{Number(item.Price) * item.Quantity}</td>
													<td>{item.info.totalItems || ""}</td>
													<td>{item.info.TotalPrice || ""}</td>
													<td>{item.info.couponDiscount || ""}</td>
													<td>{item.info.promoDiscount || ""}</td>
													<td>{item.info.PaidFromWallet || ""}</td>
													<td>{item.info.omniPointsDiscount || ""}</td>
													<td>
														{Number(item.info.couponDiscount || 0) +
															Number(item.info.promoDiscount || 0) +
															Number(item.info.PaidFromWallet || 0) +
															Number(item.info.omniPointsDiscount || 0)}
													</td>
													<td>{item.info.CustomerPhone || ""}</td>
													<td>
														{item.info.OrderSource === "Online"
															? isSfaOrder
																? "Call center"
																: "App"
															: item.info.OrderSource || ""}
													</td>
													<td>
														{isSfaOrder
															? _capitalizeText(item.info.SFAAgentName)
															: ""}
													</td>
													<td>{_capitalizeText(item.info.AgentName)}</td>
													<td>{_capitalizeText(item.info.roleName)}</td>
													<td>{item.info.OrderStatus || ""}</td>
													<td>{item.info.OrderCancelReason || ""}</td>
													<td>{item.info.Notes || ""}</td>
													<td>{item.info.OrderLocation || ""}</td>
													<td>
														{item.info.StateName ||
															item.info.statename ||
															item.info.Statename ||
															""}
													</td>
													<td>{item.info.cityname || ""}</td>
													<td>{item.info.townName || ""}</td>
													<td>
														{item.info.OrderDeliveredDate
															? dayjs(item.info.OrderDeliveredDate).format(
																	"YYYY-MM-DD H:mm",
															  )
															: ""}
													</td>
													<td>
														{item.info.OrderCancelDate
															? dayjs(item.info.OrderCancelDate).format(
																	"YYYY-MM-DD H:mm",
															  )
															: ""}
													</td>
													<td>
														{item.info.OrderRTODate
															? dayjs(item.info.OrderRTODate).format(
																	"YYYY-MM-DD H:mm",
															  )
															: ""}
													</td>
													<td>{item.info.turnAroundTime}</td>
													<td>{item.info.SOnumber || ""}</td>
													<td>{item.info.Waybillnumber || ""}</td>
													<td>{item.info.TransactionID || ""}</td>
													<td>{item.info.OrionTransactionID || ""}</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</Fragment>
						) : window.screen.width > 1124 ? (
							<button
								id="orders-xls-button"
								type="button"
								className="show--desktop"
								onClick={() => this.getOrdersList()}
							>
								<div className="show--desktop flex align-center">
									{!this.state.loading ? (
										<img
											src="Images/download-button.svg"
											alt=""
											style={{
												position: "relative",
												top: "0.5px",
												opacity: 0.6,
											}}
										/>
									) : (
										<Fragment>{this.renderLoadingCircle()}</Fragment>
									)}
									Download
								</div>
							</button>
						) : !this.state.loading ? (
							<span onClick={() => this.getOrdersList()}>
								<img
									style={{
										height: "16px",
										width: "16px",
									}}
									src="Images/download-icon-1.svg"
									alt=""
									title="download"
								/>
							</span>
						) : (
							<Fragment>{this.renderLoadingCircle()}</Fragment>
						)}
					</Fragment>
				)}
			</div>
		);
	}

	renderLoadingCircle = () => {
		return (
			<span
				className="loading-circle loading-circle-light loading-circle-small"
				style={{ marginRight: "5px" }}
			></span>
		);
	};
}

export default ExportOrders;
